<template>
  <div class="sp_step">
    <p style="color:#2B2B2B; padding:10px; margin-top:10px;">Your company may have been registered by your colleagues, you can select</p>
    <div>
      <el-radio-group v-model="companyName">
        <el-row style="max-height:325px;  margin:10px 0;">
          <el-col class="companyRadio"
                  :span="24"
                  v-for="(val,index) in companyList"
                  :key="index"
                  :class="{checkBackground:is_check==val.companyName}">
            <el-radio @change="changeCompany"
                      :label="val.companyName">{{val.content+' '+val.companyName}}</el-radio>
          </el-col>
        </el-row>
      </el-radio-group>
      <el-row>
        <el-col :span="24">
          <el-button :disabled="companyName =='' "
                     style="width:100%;height:48px; font-size:16px;"
                     type="primary"
                     @click="confirm">{{$t("loginModule.confirm")}}</el-button>
        </el-col>
        <el-col :span="24"
                style="padding:10px 0;">
          <p class="sp_register_skip">{{$t("loginModule.haveAccount")}}&nbsp;<router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
          </p>
        </el-col>
      </el-row>
    </div>

    <register-foot></register-foot>
  </div>
</template>

<script>
import registerFoot from '../../components/registerFoot.vue';
export default {
  components: { registerFoot },
  name: 'registerFour',
  props: {
    registerFourParams: {
      type: Object,
      required: true,
      default: () => { },
    }
  },
  data () {
    return {
      companyName: '',
      is_check: '',
    }
  },

  methods: {
    confirm () {
      this.$emit('registerFour', { companyName: this.companyName, isNext: true })
    },

    //设置选中的样式
    changeCompany (data) {
      this.is_check = data;
    }
  },

  computed: {
    companyList () {
      let companyList = [];
      this.registerFourParams.isPersonalMail.forEach(val => {
        if (val == 'new company') {
          companyList.push({
            companyName: val,
            content: 'Register as a',
          })
        } else {
          companyList.push({
            companyName: val,
            content: 'Register as a normal user in',
          })
        }
      })
      return companyList
    }

  },
}
</script>

<style lang="scss" scoped>
.companyRadio {
  background: rgba($color: #ddd, $alpha: 0.2);
  border-radius: 4px;
  border: 1px solid #dddddd;
  margin-bottom: 10px;
  padding: 10px;
}
.checkBackground {
  background: rgba($color: #007aff, $alpha: 0.1);
  border-radius: 4px;
  border: 1px solid #007aff;
}
</style>